import { render, staticRenderFns } from "./TeamsForm.vue?vue&type=template&id=2b9106e4&"
import script from "./TeamsForm.vue?vue&type=script&lang=js&"
export * from "./TeamsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports